import React from 'react';
import ReactDOM from 'react-dom';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';
import ProductSwatchesMultiple from './ProductSwatchesMultiple/ProductSwatchesMultiple';

const UILocale = require('../../utils/UILocale.js');
const UISettings = require('../../utils/UISettings.js');
const Analytics = require('../../analytics.js');

export default function initProductSwatches() {
  const productVariants = UISettings.get('productVariants');
  let productSwatches = [];


  Object.keys(productVariants).forEach((productVariantName) => {
    // Some variants are present in JSON but not implemented (only some dummy data are present).
    // It's also on production. So variant attr which is not array is not used.
    if (productVariants[productVariantName].variants instanceof Array) {
      productVariants[productVariantName].isHelpTooltipVisible = false;
      productSwatches.push(productVariants[productVariantName]);
    }
  });

  Analytics.setAvailableSwatchesForProductOnProductPage(productSwatches);

  function onSwatchClick(swatchName, variantsCount, swatchData) {
    Analytics.onSwatchClickOnProductPage(swatchData.variant,
      swatchData.fupid, swatchName, variantsCount);
  }

  // State of HelpTooltip have to be stored globaly for all instances of Swatches.
  // There are two complete different components for Swatches DIVs (tablets, desktop/mobile).
  function onChangeHelpTooltipVisibility(swatchTitle, isVisible) {
    productSwatches = (productSwatches.map((swatch) => {
      swatch.isHelpTooltipVisible = swatch.title === swatchTitle ? isVisible : swatch.isHelpTooltipVisible;
      return swatch;
    }));
    renderSwatchesBlocks(productSwatches);
  }

  function getHelpTooltipVisibility(swatchTitle) {
    return (productSwatches.find((swatch) => swatch.title === swatchTitle)).isHelpTooltipVisible;
  }

  function renderSwatchesBlocks(productSwatches) {
    ['.left-div', '.no-tablet'].forEach((parentSelector) => {
      const rootEl =
              document.querySelector(`${parentSelector} [data-component="product-swatches"]`);

      const props = {
        productSwatches: productSwatches,
        onSwatchClick: onSwatchClick,
        onChangeHelpTooltipVisibility: onChangeHelpTooltipVisibility,
        getHelpTooltipVisibility: getHelpTooltipVisibility,
        // Translations:
        availableOptionsTranslate: UILocale.getString('component.productswatches.header'),
        emailMeWhenBackInStockTranslate:
                  UILocale.getString('component.productswatches.email_me_when_back_in_stock'),
        priceSaveTranslate: UILocale.getString('component.productswatches.save'),
        outOfStockTranslate: UILocale.getString('component.productswatches.outofstock')

      };

      if (rootEl) {
        ReactDOM.render(
          <EnvironmentThemeProvider>
            <ProductSwatchesMultiple {...props} />
          </EnvironmentThemeProvider>, rootEl
        );
      }
    });
  }

  // Init
  renderSwatchesBlocks(productSwatches);
}
